<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2024-05-10 17:35:20
 * @LastEditors: whaoo
 * @LastEditTime: 2024-06-24 09:38:11
-->
<template>
  <div class="sidebar">
    <img src="../../assets/sidebar_bg.png" class="sidebar_bg" alt />
    <div class="z_2 sidebar_box">
      <el-menu
        background-color="#ffffff00"
        :router="true"
        :default-active="activeIndex"
        text-color="#2F3538"
        active-text-color="#ffffff"
      >
        <el-menu-item index="/all_device_data">实时体征监测</el-menu-item>
        <el-menu-item index="/device_list">护理服务报告</el-menu-item>
        <el-menu-item index="/device_manage">设备管理</el-menu-item>
        <el-menu-item index="/huanz_list">患者列表</el-menu-item>
        <el-menu-item index="/sleep_report">睡眠质量分析</el-menu-item>
        <el-menu-item index="/activity_report">运动健康分析</el-menu-item>
        <el-menu-item index="/activity_statics">活动情况统计</el-menu-item>
        <el-menu-item index="/device_log">设备使用日志</el-menu-item>
        <el-menu-item index="/gateway_administration">网关管理</el-menu-item>
        
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeIndex: "",
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = this.$route.path;
    },
  },
  mounted() {
     this.activeIndex = this.$route.path;
  },

  methods: {},
};
</script>
<style  scoped>
.sidebar {
  height: calc(100% - 88px);
  position: relative;
  width: 100%;
}
.sidebar_bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.z_2 {
  z-index: 2;
  position: relative;
}
.sidebar_box {
  padding: 22px 10px;
}
.sidebar_box >>> .el-menu-item {
  border-radius: 10px;
}
.sidebar_box >>> .el-menu-item:hover {
  background-color: #57a8ffaa !important;
}
.sidebar_box >>> .el-menu-item.is-active {
  background-color: #57a8ff !important;
}
</style>


// WEBPACK FOOTER //
// src/view/layout/sidebar.vue